import { APIClient } from "./axiosClient";

export interface DocumentUploadRequest {
  programId: number;
  documentName: string;
}

export interface DocumentUploadResponse {
  originalFileName: string;
  storedFileName: string;
  fileUrl: string;
  documentName: string;
  fileType: string;
  fileSize: number;
  programVO: any;
  uploadedBy: string;
  uploadDateTime: string;
  id: number;
}

export class DocumentApi {
  static uploadDocumentForProgram(file: File, documentUploadRequest: DocumentUploadRequest) {
    const formData = new FormData();
    formData.append('file', file);
    
    const documentUploadRequestBlob = new Blob([JSON.stringify(documentUploadRequest)], { 
      type: 'application/json' 
    });
    formData.append('documentUploadRequestVO', documentUploadRequestBlob);

    return APIClient(
      '/document/uploadForProgram',
      formData,
      { 
        requestType: 'post', 
        contentType: 'multipart/form-data' 
      }
    );
  }

  static uploadDocumentForMerchant(file: File, documentUploadRequest: { merchantId: number; documentName: string }) {
    const formData = new FormData();
    formData.append('file', file);
    
    const documentUploadRequestBlob = new Blob([JSON.stringify(documentUploadRequest)], { 
      type: 'application/json' 
    });
    formData.append('documentUploadRequestVO', documentUploadRequestBlob);

    return APIClient(
      '/document/uploadForMerchant',
      formData,
      { 
        requestType: 'post', 
        contentType: 'multipart/form-data' 
      }
    );
  }

  static getDocumentsForProgram(programId: number) {
    return APIClient(
      `/document/program/${programId}`,
      {},
      { requestType: 'get' }
    );
  }

  static getDocumentsForMerchant(merchantId: number) {
    return APIClient(
      `/document/merchant/${merchantId}`,
      {},
      { requestType: 'get' }
    );
  }

  static downloadDocument(documentId: number) {
    return APIClient(
      `/document/download/${documentId}`,
      {},
      { 
        requestType: 'get',
        responseType: 'blob'
      }
    );
  }

  static deleteDocument(documentId: number) {
    return APIClient(
      `/document/${documentId}`,
      {},
      { requestType: 'delete' }
    );
  }
} 